import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Col,
  Row,
  Spin,
  Upload,
  Checkbox,
  Radio,
} from 'antd'
import apiRequest from '../hooks/apiRequest'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
const { TextArea } = Input
const { Option } = Select

const DynamicProductForm = ({
  form,
  productId,
  customerDetail,
  policyData,
  type,
}) => {
  const [fields, setFields] = useState([])
  const [dropdownOptions, setDropdownOptions] = useState({})
  const [loading, setLoading] = useState(false)
  const [DynamicFormData, setDynamicFormData] = useState()
  const { getFieldDecorator, setFieldsValue } = form
  const DisableFields = type == 'broker'
  const { policyNumber } = useParams()
  const history = useHistory();
  console.log('policyData', fields)
  const loggedInUserID = localStorage.getItem('loggedInUserID');
  const loggedInUserName = localStorage.getItem('username');


  useEffect(() => {
    const fetchFieldsAndValues = async () => {
      if (!policyData?.productId) return
      setLoading(true)
      try {
        const fieldRes = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/ClaimForm/GetfieldsByproduct/${policyData?.productId}/${policyData?.insurerId}`,
          'GET',
        )
        if (fieldRes?.success && Array.isArray(fieldRes.data)) {
          setFields(fieldRes.data)
          if (type === 'broker' && policyNumber) {
            const valueRes = await apiRequest(
              `${process.env.REACT_APP_BASE_URL}/ClaimForm/get-by-policy/${policyNumber}`,
              'GET',
            )

            if (valueRes?.success) {
              const values = valueRes?.data?.data?.values || {}
              setDynamicFormData(valueRes?.data?.data)
              setTimeout(() => {
                form.setFieldsValue(values)
              }, 0)
            }
          }
        } else {
          setFields([])
        }
      } catch (error) {
        console.error('Error fetching fields or values:', error)
        setFields([])
      } finally {
        setLoading(false)
      }
    }

    fetchFieldsAndValues()
  }, [policyData?.productId, type, policyNumber])

  //  Fetch dropdown options for dynamic dropdown fields
  useEffect(() => {
    const dynamicKeys = [
      ...new Set(
        fields
          .filter(f => (f.type || '').toLowerCase() === 'dropdown')
          .map(f => f.fieldKey.toLowerCase()),
      ),
    ]

    const fetchDropdowns = async () => {
      const newOptions = {}

      for (const key of dynamicKeys) {
        const normalizedKey = key.toLowerCase()
        let endpoint = ''

        if (normalizedKey.includes('insurer')) {
          endpoint = '/api/Insurer/GetAllInsurers'
        } else if (normalizedKey.includes('gender')) {
          newOptions[normalizedKey] = [
            { label: 'Male', value: 'Male' },
            { label: 'Female', value: 'Female' },
            { label: 'Other', value: 'Other' },
          ]
          continue
        } else {
          newOptions[normalizedKey] = [
            { label: 'Option 1', value: 'Option1' },
            { label: 'Option 2', value: 'Option2' },
          ]
          continue
        }
        try {
          const res = await apiRequest(endpoint, 'GET')
          if (res.success && Array.isArray(res.data)) {
            newOptions[normalizedKey] = res.data.map(item => ({
              label: item.insurer_name || item.full_name || 'N/A',
              value: item.insurer_id || item.id || '',
            }))
          } else {
            newOptions[normalizedKey] = []
          }
        } catch (error) {
          console.error(`Error fetching options for ${normalizedKey}:`, error)
          newOptions[normalizedKey] = []
        }
      }
      setDropdownOptions(newOptions)
    }

    if (dynamicKeys.length > 0) {
      fetchDropdowns()
    }
  }, [fields])

  const renderFormItem = field => {
    const rules = field.isRequired
      ? [{ required: true, message: `${field.name} is required` }]
      : []

    const fieldType = (field.type || '').toLowerCase()
    const fieldKey = field.fieldKey.toLowerCase()

    const commonProps = {
      disabled: DisableFields,
      placeholder: `Enter ${field.name}`,
    }

    switch (fieldType) {
      case 'text':
        return (
          <Col xs={24} md={6} key={field.id}>
            <Form.Item label={field.name}>
              {getFieldDecorator(fieldKey, { rules })(<Input {...commonProps} />)}
            </Form.Item>
          </Col>
        )

      case 'textarea':
        return (
          <Col xs={24} md={12} key={field.id}>
            <Form.Item label={field.name}>
              {getFieldDecorator(fieldKey, { rules })(
                <Input.TextArea rows={4} {...commonProps} />,
              )}
            </Form.Item>
          </Col>
        )

      case 'number':
        return (
          <Col xs={24} md={6} key={field.id}>
            <Form.Item label={field.name}>
              {getFieldDecorator(fieldKey, { rules })(
                <Input type="number" {...commonProps} />,
              )}
            </Form.Item>
          </Col>
        )

      case 'currency':
        return (
          <Col xs={24} md={6} key={field.id}>
            <Form.Item label={field.name}>
              {getFieldDecorator(fieldKey, { rules })(
                <Input prefix="₹" {...commonProps} />,
              )}
            </Form.Item>
          </Col>
        )

      case 'dropdown':
      case 'lookup': {
        const rawOptions = dropdownOptions[fieldKey] || []
        const options = rawOptions
          .map(opt => {
            const value = opt?.value ?? opt?.id ?? opt?.name
            const label =
              opt?.label ?? opt?.full_name ?? opt?.insurer_name ?? opt?.name
            return value && label ? { value, label } : null
          })
          .filter(Boolean)

        return (
          <Col xs={24} md={6} key={field.id}>
            <Form.Item label={field.name}>
              {getFieldDecorator(fieldKey, { rules })(
                <Select
                  placeholder={`Select ${field.name}`}
                  disabled={DisableFields}>
                  {options.length > 0 ? (
                    options.map(opt => (
                      <Option key={String(opt.value)} value={String(opt.value)}>
                        {opt.label}
                      </Option>
                    ))
                  ) : (
                    <>
                      <Option value="Option1">Option 1</Option>
                      <Option value="Option2">Option 2</Option>
                    </>
                  )}
                </Select>,
              )}
            </Form.Item>
          </Col>
        )
      }

      case 'radiobutton':
        return (
          <Col xs={24} md={6} key={field.id}>
            <Form.Item label={field.name}>
              {getFieldDecorator(fieldKey, { rules })(
                <Radio.Group disabled={DisableFields}>
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>
        )

      case 'checkbox':
        return (
          <Col xs={24} md={6} key={field.id}>
            <Form.Item>
              {getFieldDecorator(fieldKey, { valuePropName: 'checked' })(
                <Checkbox disabled={DisableFields}>{field.name}</Checkbox>,
              )}
            </Form.Item>
          </Col>
        )

      case 'fileupload':
        return (
          <Col xs={24} md={6} key={field.id}>
            <Form.Item label={field.name}>
              {getFieldDecorator(fieldKey, { rules })(
                <Upload beforeUpload={() => false} disabled={DisableFields}>
                  <Button icon="upload">Click to Upload</Button>
                </Upload>,
              )}
            </Form.Item>
          </Col>
        )

      case 'datepicker':
        return (
          <Col xs={24} md={6} key={field.id}>
            <Form.Item label={field.name}>
              {getFieldDecorator(fieldKey, { rules })(
                <DatePicker style={{ width: '100%' }} disabled={DisableFields} />,
              )}
            </Form.Item>
          </Col>
        )

      case 'datetimepicker':
        return (
          <Col xs={24} md={6} key={field.id}>
            <Form.Item label={field.name}>
              {getFieldDecorator(fieldKey, { rules })(
                <DatePicker
                  showTime
                  style={{ width: '100%' }}
                  disabled={DisableFields}
                />,
              )}
            </Form.Item>
          </Col>
        )

      default:
        return null
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const value = await form.validateFields()
      const values = Object.entries(value).reduce(
        (acc, [key, val]) => {
          acc[key] = val !== null && val !== undefined ? String(val) : ''
          return acc
        },
        {},
      )
      const claimId =
        DynamicFormData && DynamicFormData.id
          ? DynamicFormData.id.toString()
          : ''

      const payload = {
        id: 0,
        policyNo: policyData?.policyNo || '',
        claimId,
        insurerId: policyData?.insurerId || 0,
        brokerId: policyData?.brokerInfo?.brokerId || 0,
        customerId: customerDetail?.id || 0,
        values,
      }
      debugger;
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/ClaimForm/submit`,
        'POST',
        payload,
      )
      if (res?.success) {
        toast.success('Claim submitted successfully')
        const url = `${process.env.REACT_APP_BASE_URL}/Claim/SendClaimRequest/send-claim-request`
        const payload = {
          toEmail: policyData?.brokerInfo?.notifyBroker,
          policyNumber: policyData.policyNumber,
          type: '',
          BrokerId: policyData?.brokerInfo?.brokerId,
          BrokerName: policyData?.brokerInfo?.notifyBroker,
        }
        const ApiRequest = await apiRequest(url, 'POST', payload)
        history.push('/claims');
      } else {
        toast.error(res?.message || 'Failed to submit claim')
      }
    } catch (err) {
      console.error('Validation or API error:', err)
      toast.error('Something went wrong during submission')
    }
  }
  debugger

  if (loading) {
    return <Spin tip="Loading form fields..." />
  }

  if (fields.length === 0) {
    return <p style={{ padding: 16 }}>No fields to show.</p>
  }

  return (
    <Form layout="vertical" onSubmit={handleSubmit}>
      <Row gutter={16}>
        {fields.map(field => renderFormItem(field))}
        {!DisableFields && (
          <Col span={24}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Col>
        )}
      </Row>
    </Form>
  )
}

export default Form.create()(DynamicProductForm)
